import { List, Map } from 'immutable';
import { types as archivedJobTypes } from '@saucelabs/sl-module-archived-jobs';
import { types as userTypes } from '@saucelabs/sl-module-user';

import * as types from './types';
import * as queryTypes from './../query/types';


const initialState = new Map({
  initialized: false,
  searchLoading: true,
  queryError: false,
  selectedJobs: new List(),
  savedQueries: new List(),
  siblings: new List(),
});


const archivesReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case types.INITIALIZED:
      return state.set('initialized', true);
    case queryTypes.SEARCH.REQUEST:
      return state
        .set('searchLoading', true)
        .set('queryError', false);
    case queryTypes.SEARCH.SUCCESS:
      return state.set('searchLoading', false);
    case queryTypes.SEARCH.FAILURE:
      return state
        .set('searchLoading', false)
        .set('queryError', true);
    case types.JOB_SELECTION_TOGGLE: {
      const id = payload.get('id');
      const index = state.get('selectedJobs').indexOf(id);
      return index === -1 ?
        state.update('selectedJobs', (list) => list.push(id)) :
        state.update('selectedJobs', (list) => list.delete(index));
    }
    case types.JOB_SELECTION_CLEAR:
      return state.set('selectedJobs', initialState.get('selectedJobs'));
    case types.CLEANUP:
      return initialState;
    case archivedJobTypes.GET_SAVED_QUERIES.SUCCESS:
      return state.set('savedQueries', new List(payload.items));
    case archivedJobTypes.SAVE_QUERY.SUCCESS:
      return state.set('savedQueries', state.get('savedQueries').insert(0, payload));
    case userTypes.SIBLINGS_GET.SUCCESS:
      return state.set('siblings', new List(payload));
    default:
      return state;
  }
};

export default archivesReducer;
